import React from "react";
import { RelatedArticleResultItem, NoRelatedResults } from ".";

// const ArticleInterface = {
//   character: '',
//   organization: '',
//   location: '',
//   generic: '',
// }

export function RelatedArticleResults({
  results,
  articleType,
  highlightedOption,
  onSelect,
  term,
  isLoading,
}) {
  // console.log('RESULTS LIST LENGTH', results.length);
  return (
    <div className="chronos-article-picker-results">
      {results.map((r, i) => (
        <RelatedArticleResultItem
          isHighlighted={i === highlightedOption}
          article={r}
          key={r.id}
          onSelect={onSelect}
        />
      ))}
      {results.length === 0 && <NoRelatedResults isLoading={isLoading} />}
    </div>
  );
}
